<template>
  <div >
    <van-nav-bar class="nav-bar">
      <template #left>
        <img @click="$router.push('/')" src="img/home.png" style="width: 30px; ">
      </template>
      <template #right>
        <img @click="service" style="width: 30px; "
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABXJJREFUaEPVmb2yDUEUhZdcFV7AzxMgUSVCgBClxHgCPIBCkeMF/IQkSAkQCxCQ4gnwAIr6bs06tc8+09M9c2YCXXXr3nvOme691l577e4+u/Sfj10LxH9E0p5u3pOSvnc/vPR+7vXmALBX0jlJBHteEv8PjXeSXkp6FYBNxrUNAAK9Jul6Q9ClAJ9Ieijp01QEUwFckXR/IPDPkn6loE4MBPlA0p2eZ6q4xgKA9cedVOLkvyXBpuVRWpj6QGoQcDh9iFq5MDYbYwAQ/FtJBOFB4LDHT2a8xh5AbkuKmWEOQEBE02gF0Bc8RQiTfYEflHQgAS3pnBpCjnFc7TJaBdEK4GNi/kbHuhcA4OVOHjBbciJAwC6Fi2Q8yCqv234h5VSLnFoAIA/cxiOyQ6Cwl+2zr4hjf2AuAqZwLZcMArCAGJRmDQBsonsPFkS3DEDxt9l+2vk7Hl8aBAlYpGeJUfxklEAzCDKFxIqjBuCbJPTMoIsCiIETEQSDwFlkbBHzDAQgG9gms/zONXFoqOENAcjseyLXAw4Em82O0UMj2SNjOFHUPXPanSDIZG1MMQQA6ZhxT2Lm0TjBx0IcynTtPWSECQACopBSlG4xCyUAyAb5eDABLNySBPO8P1YyGQRBModJMAhkdLTLrLOQXW81VwkAwcK2tY8ukQ6DySfvXbqsMjckIBWcxoN56dAuasdgUM0SQpfsMBlMhpT4P7pQTRal93+mPhHZJSsQ5XowaczlrQpyLmaACfB1a58P0tpfzCQdGwOO5qwSLFnNUoKsaLcOGnKJaWdECZFSEOMM6JyBxbEAr83Bvi3Sc7lJRqdx/XldYrELYbtIbNVMI4A8GROhPbf3QT9u0BMkQBDzuo54DeZZI84fbTQSh/OhhhXgCMAPUVT2dhDbeWonrSEMSJOC5HdsiDzjNWIWbCLZ8aIEd2ReA+B0svMEfcsgSNLMsyzC/wZP/+C1aMExC/uCZMkMqvDWhbVHA3D1IyUmy8PB8tuHlT6QBI6L9M3hNWhk0ZEcfAQ7CQBMwlL0frKBW3mfFINGIrDH5719rmVuI7Au43ljOAuA2OR+dHsZB7tNg/ubnJHgkU+ccxIAUm8JudGwVrG91+guvG8TsUPR8Hzq8yOjAeQidoeeoydkHLZxmhQSdBeO9joagC2OQsIhSPNcm7kMwGtBDgP7ZkSyLN+VK0Yb9QRIhk4XOzMT8Rpenn18omI2HosA2HfF2w+yYxljKL2dOHderwDjdEoaDVa3NACvg0EAyjtSx7N2wMnbaVDzEAz4sgr0nA3QpW2zdhSdkhVnwM/aJFiT2qM5btReayA+bHhyCm3o8L4tgFxn3oJvnEVaAeQT2uA5tRL9bkn7JX1Nn4sbuGjRdh4ktdE4WwGwVmxgPruOPVaelnRX0k1JbxIAs5xrzGfzXuseAyDuWbK9ORZ0TJBfOtcwy8ck8XOxC/5eCj7uPqlDH27izYg3emuPjgWAhVEPPm72nY8vSXpekNEHSccl/Qnv+5xAgATsrUO8jy1ecI0F4HXjDULf9d/ZLtAz3e9nkh5Jet0DjAOKbz3ivide4eQt+GqaqQCYgB0pQAiAxjJlECSOg/RiPcWbv8FbkG0AEDBp5pwLc1NsFb1H1n1Z7DNw9Zp9WwBTWC89g0x8X0RWYj0U11kKgL8AZGEcZe0uJ0VDoGzcfJXD6Y0MNJ0tlgCQN4G231gn8WtZNyd/XRXPwNUMLwHADgXrdFf2UmwG+Tse8B0cHdbn5bGNce1Wooq28QP5ZJW/4WEaZOJvNLe5nl8EQOwRBOdvWPwV6lxX8jt8LiEhCpjA4/fAVTtszO7Gx5YA4EV8qUV/mJX1iGJJAFNJHfXcP/mqiEDZsEJxAAAAAElFTkSuQmCC">
      </template>
    </van-nav-bar>
    <div class="convention-hall page" style="margin-top: 16vw">

      <div style="overflow-y: auto;">

        <div style="padding: 0px 30px; display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px 30px;">
          <div class="newGame" v-for="(item,key) in gameitem" :key="key" @click="toLottery(item.key,item.id,item.is_type)">
            <ul>
              <li>
                <div class="image">
                  <img  :src="item.ico" alt="">
                </div>
                <p>{{ item.name }}</p>
                <span>{{ $t("每次3分钟").replace("3",item.rule) }}</span>
              </li>
            </ul>
          </div>

        </div>
        <div style="height: 100px"></div>
      </div>
      <div class="convention-item area news" v-if="false">
        <div class="brands" style="margin-top: 10px;">
          <div class="item" v-for="(item,key) in gameitem" :key="key" @click="toLottery(item.key,item.id)">
            <img class="mr-[16rpx] w-[80rpx] h-[80rpx]" :src="item.ico">
            <div>
              <div class="name u-font-28 u-line-1 mb-[12rpx]">{{ item.name }}</div>
              <div class="frequency u-font-24"></div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {Toast} from 'vant';

export default {
  data() {
    return {
      gameitem: [{}, {}, {}, {}],
      lotteryitem: [{}, {}, {}, {}],
      isLoading: false,
      activeKey: 0,
    };
  },
  methods: {
    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },
    onRefresh() {
      setTimeout(() => {
        Toast(this.$t("msg.刷新成功！"));
        this.isLoading = false;
      }, 500);
    },
    toLottery(key, id,is_type) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        if(is_type == 0){
          this.$router.push({path: '/Grab'})
        }else{
          this.$router.push({path: '/Lottery?key=' + key + "&id=" + id})
        }
      }
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
      })
    },
    onChange(index) {
      this.$http({
        method: 'get',
        data: {class: index},
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
      })
    },
    getLotteryItem() {
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res => {
        this.lotteryitem = res.data;
      })
    }
  },
  created() {
    this.getGameItem();//获取首页游戏列表
    this.getLotteryItem();
  }
};
</script>

<style lang='less' scoped>
.convention-hall{
  width: 100%;
  background: url(/img/lo.png) no-repeat top / 100%, url(/img/lo2.png) no-repeat bottom / 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.newGame{
  width: 92%;
  margin: 0 auto
}

.newGame ul{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 1.33333rem
}

.newGame ul[data-v-407882c8]:after {
  content: "";
  width: 31%;
  height: 0
}

.newGame ul li{
  width: 100%;
  background: #fff;
  margin: 0 0 .66667rem;
  border: 2PX solid #b78aed;
  border-radius: .66667rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center
}

.newGame ul li .image{
  width: 5.66667rem;
  height: 5.66667rem;
  border-radius: .66667rem;
  overflow: hidden;
  margin-top: 18px;
}

.newGame ul li .image img{
  width: 100%
}

.newGame ul li p{
  font-size: .93333rem;
  font-weight: 600;
  color: #180d37;
  margin: 10px 0;
}

.newGame ul li span{
  font-size: .8rem;
  color: #301f4f;
  line-height: 80px;
}
</style>
